import { RegionsAndPickupContainer } from '@/modules/Regions';

const Categories = (): JSX.Element => <RegionsAndPickupContainer />;

export default Categories;
